import { Component } from "react";
import Select from "react-select";

class DropDownListS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValueS: "",
    };
  }

  componentDidMount() {
    this.setState({ selectedValueS: this.props.selectedValue });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedValue !== this.props.selectedValue) {
      this.setState({ selectedValueS: this.props.selectedValue });
    }
  }
  // handle onChange event of the dropdown
  handleChange = (selectedOption) => {
    this.setState({
      selectedValueS: selectedOption ? selectedOption.value : "",
    });
    this.props.onUpdateSelectedValue(
      selectedOption ? selectedOption.value : ""
    );
  };

  render() {
    const { selectedValueS } = this.state;
    const { data } = this.props;
    const { placeholder, width, placeholderColor, compact = false, disabled = false } = this.props;
    // console.log(data, selectedValueS);

    return (
      <div className={`DropDownList ${width ? `w-${width}` : ``}`}>
        <Select
          className="dropdown"
          placeholder={placeholder}
          value={data && data.filter((obj) => selectedValueS === obj.value)}
          options={data} // set list of the data
          isDisabled={disabled}
          onChange={this.handleChange} // assign onChange function
          isClearable
          menuPlacement="auto"
          menuPosition="fixed"
          styles={{
            control: (provided) => ({
              ...provided,
              cursor: 'pointer',
              paddingTop: compact ? '2px' : '10px',
              paddingBottom: compact ? '2px' : '10px',
            }),
            clearIndicator: (provided) => ({
              ...provided,
              display: 'none', // Hide the clear button
            }),
            placeholder: (provided) => ({
              ...provided,
              color: placeholderColor || '#6c757d', // Default Bootstrap placeholder color
            }),
          }}
        />
      </div>
    );
  }
}

export default DropDownListS;